import { createTheme } from "@material-ui/core/styles";
import { primaryColor, secondaryColor } from "./constants";

const theme = createTheme({
  typography: {
    fontFamily: "Lato"
  },
  palette: {
    type: "light",
    primary: { main: primaryColor },
    secondary: { main: secondaryColor }, // This is just green.A700 as hex.
    text: {
      primary: "#545455",
      secondary: "#000000"
    }
  }
});

export default theme;
